export const BUILD_VERSION = '1774551997';
